var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#1ED760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5953 16.4338C16.4162 16.7276 16.0317 16.8207 15.7379 16.6404C13.39 15.2062 10.4343 14.8814 6.95348 15.6767C6.61805 15.7531 6.2837 15.543 6.20727 15.2074C6.13049 14.8719 6.33982 14.5375 6.67608 14.4611C10.4853 13.5904 13.7528 13.9655 16.3887 15.5764C16.6825 15.7567 16.7756 16.14 16.5953 16.4338ZM17.8193 13.7105C17.5936 14.0777 17.1136 14.1936 16.747 13.9679C14.059 12.3153 9.96159 11.8368 6.78224 12.8019C6.36991 12.9265 5.93441 12.6941 5.80927 12.2825C5.68508 11.8701 5.91758 11.4354 6.32919 11.3101C9.96088 10.2081 14.4757 10.7419 17.5625 12.6388C17.9291 12.8645 18.045 13.3444 17.8193 13.7105ZM17.9244 10.8751C14.7014 8.9608 9.384 8.78478 6.30686 9.71873C5.81273 9.8686 5.29019 9.58964 5.14044 9.0955C4.9907 8.60112 5.26941 8.07892 5.76389 7.9287C9.29623 6.85635 15.1683 7.06354 18.8789 9.26639C19.3243 9.53017 19.47 10.1042 19.2061 10.5481C18.9434 10.9925 18.3674 11.1391 17.9244 10.8751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.e41804c5689b4c1ebbbef616f0f4f6e8.svg";
export { ForwardRef as ReactComponent };